import './styles.css';
import { useEffect, useState } from "react";
import Loader from "../../../../../Components/Shared/Loader";
import { GrantsModel } from "../../../../../Models/GrantsModel";
import { IOpportunitiesProjectGroupingLines } from "../../../../../Interfaces/IOpportunitiesPanels";

interface isSubventionProps {
    objective: string,
    eligible: string,
    values: string,
    counterpart: string,
    deadline: string
}

interface isNotSubventionProps {
    objective: string,
    financialItems: string,
    taxes: string,
    bankParticipation: string,
    deadline: string
}

interface IFavGrantsLines {
    grants?: GrantsModel,
    grantsProjectGrouping?: IOpportunitiesProjectGroupingLines
}

const FavGrantsModelInfo = (props: IFavGrantsLines) => {
    const [isSubvention, setIsSubvention] = useState<isSubventionProps>();
    const [isNotSubvention, setIsNotSubvention] = useState<isNotSubventionProps>();
    const [loading, setLoading] = useState<boolean>(false);

    function buildObj() {
        var title = props.grants?.title ?? props.grantsProjectGrouping?.favoritesGrantsName ?? "";
        var text = props.grants?.description?.trim().split(/\n+/) ?? props.grantsProjectGrouping?.favoritesGrantDescription?.trim().split(/\n+/) ?? [];

        if (title?.toLowerCase().startsWith("subvenção")) {
            let textObject: isSubventionProps = {} as isSubventionProps;
            text.forEach((line, index) => {
                let lineToCompare = line.toLowerCase().trim();
                let lineToSet = line.trim();
                let firstIndex = lineToSet.indexOf(":");
                switch (true) {
                    case lineToCompare.startsWith("objetivo:"):
                        textObject.objective = lineToSet.slice(firstIndex + 1);
                        break;
                    case lineToCompare.startsWith("elegibilidade:"):
                        textObject.eligible = lineToSet.slice(firstIndex + 1);
                        break;
                    case lineToCompare.startsWith("valores:"):
                        textObject.values = lineToSet.slice(firstIndex + 1);
                        break;
                    case lineToCompare.startsWith("contrapartida:"):
                        textObject.counterpart = lineToSet.slice(firstIndex + 1);
                        break;
                    case lineToCompare.startsWith("prazos:") || lineToCompare.startsWith("prazo:"):
                        textObject.deadline = lineToSet.slice(firstIndex + 1);
                        break;
                    default:
                        break;
                }
            });
            setIsSubvention(textObject);
        } else {
            let textObject: isNotSubventionProps = {} as isNotSubventionProps;
            text.forEach((line, index) => {
                let lineToCompare = line.toLowerCase().trim();
                let lineToSet = line.trim();
                let firstIndex = lineToSet.indexOf(":");
                switch (true) {
                    case lineToCompare.startsWith("objetivo:"):
                        textObject.objective = lineToSet.slice(firstIndex + 1);
                        break;
                    case lineToCompare.startsWith("itens financiáveis:"):
                        textObject.financialItems = lineToSet.slice(firstIndex + 1);
                        break;
                    case lineToCompare.startsWith("taxas:"):
                        textObject.taxes = lineToSet.slice(firstIndex + 1);
                        break;
                    case lineToCompare.startsWith("participação do banco:"):
                        textObject.bankParticipation = lineToSet.slice(firstIndex + 1);
                        break;
                    case lineToCompare.startsWith("prazos:") || lineToCompare.startsWith("prazo:"):
                        textObject.deadline = lineToSet.slice(firstIndex + 1);
                        break;
                    default:
                        break;
                }
            });
            setIsNotSubvention(textObject);
        }
    }

    useEffect(() => {
        if (props.grants != null && props.grants != undefined && props.grants.title != undefined) {
            buildObj();
        }
    }, [props.grants]);

    return (
        <>
            {loading && <Loader />}
            <div className='mx-2 mt-2 mb-2'>
                {isSubvention !== undefined ?
                    <>
                        <h5 className="line-body mb-4 text-observation">
                            <b>Objetivo:</b> {isSubvention.objective}
                        </h5>
                        <h5 className="line-body mb-4 text-observation">
                            <b>Elegibilidade:</b> {isSubvention.eligible}
                        </h5>
                        <h5 className="line-body mb-4 text-observation">
                            <b>Valores:</b> {isSubvention.values}
                        </h5>
                        <h5 className="line-body mb-4 text-observation">
                            <b>Contrapartida:</b> {isSubvention.counterpart}
                        </h5>
                        <h5 className="line-body mb-4 text-observation">
                            <b>Prazos:</b> {isSubvention.deadline}
                        </h5>
                    </>
                    :
                    isNotSubvention !== undefined ?
                        <>
                            <h5 className="line-body mb-4 text-observation">
                                <b>Objetivo:</b> {isNotSubvention.objective}
                            </h5>
                            <h5 className="line-body mb-4 text-observation">
                                <b>Itens Financiáveis:</b> {isNotSubvention.financialItems}
                            </h5>
                            <h5 className="line-body mb-4 text-observation">
                                <b>Taxas:</b> {isNotSubvention.taxes}
                            </h5>
                            <h5 className="line-body mb-4 text-observation">
                                <b>Participação do Banco:</b> {isNotSubvention.bankParticipation}
                            </h5>
                            <h5 className="line-body mb-4 text-observation">
                                <b>Prazos:</b> {isNotSubvention.deadline}
                            </h5>
                        </>
                        :
                        <></>
                }
            </div >
        </>
    )
}

export default FavGrantsModelInfo